var _line, _line2, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineDiagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 78,
    viewBox: "0 0 221 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 76.5,
    x2: 218.5,
    y2: 76.5,
    stroke: "#CCCCCC",
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 76.5,
    x2: 1.5,
    y2: 2.5,
    stroke: "#CCCCCC",
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 70.5C29.6498 70.5 33.8502 47 61.75 47C89.6498 47 78.8502 32 106.75 32C134.65 32 127.35 5 155.25 5C183.15 5 191.35 1.5 219.25 1.5",
    stroke: "url(#paint0_linear)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 76.5C29.0101 76.5 45.4899 62.5 72.75 62.5C100.01 62.5 98.4899 56 125.75 56C153.01 56 149.99 41.5 177.25 41.5C204.51 41.5 190.99 15.5 218.25 15.5",
    stroke: "url(#paint1_linear)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 218.777,
    y1: 18.002,
    x2: 9.66244,
    y2: 18.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 219.75,
    y1: 27.3748,
    x2: 7.18627,
    y2: 27.9795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E323FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#540FC9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDiagram);
export default __webpack_public_path__ + "static/media/line-diagram.bbbcbdf9a4c92f43e47e250f469844f9.svg";
export { ForwardRef as ReactComponent };